import type { ReactNode } from "react";
import { ConnectionStoreContext } from "./connectionContext";
import { useConnectionStore, type ProviderId } from "./useConnectionStore";

/**
 * Owns the single connection-store instance for the app tree. Hoisted above
 * AppRuntime so connection-scoped data hooks (usePipelineList, useCompareContext,
 * useSourceSelection, …) can read the resolved view identity from context
 * instead of ambient module state.
 */
export function ConnectionProvider({
  initialProvider,
  children,
}: {
  initialProvider?: ProviderId;
  children: ReactNode;
}) {
  const store = useConnectionStore({ initialProvider });
  return (
    <ConnectionStoreContext.Provider value={store}>{children}</ConnectionStoreContext.Provider>
  );
}
